import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { getAccountDriveFiles, updateAccountSettings } from '../api';

export const accountDriveKeys = {
  all: ['account-drive-files'] as const,
  folder: (accountId: string, folderId?: string | null) =>
    [...accountDriveKeys.all, accountId, folderId ?? 'root'] as const,
};

export function useAccountDriveFiles(accountId: string, folderId?: string | null) {
  return useQuery({
    queryKey: accountDriveKeys.folder(accountId, folderId),
    queryFn: () => getAccountDriveFiles(accountId, folderId ?? undefined),
    enabled: !!accountId,
  });
}

export function useSetAccountDriveFolder(accountId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (gdriveRootFolderId: string | null) =>
      updateAccountSettings(accountId, { gdriveRootFolderId }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: accountDriveKeys.folder(accountId) });
      queryClient.invalidateQueries({ queryKey: ['account', accountId] });
      queryClient.invalidateQueries({ queryKey: ['account-dashboard', accountId] });
      toast.success('Drive folder updated');
    },
    onError: (error) => {
      toast.error(error instanceof Error ? error.message : 'Failed to update Drive folder');
    },
  });
}
